<template>
  <main class="content">
    <div class="container-fluid p-0">
      <div class="mb-3">
        <h1 class="h3 d-inline align-middle"><i class="align-middle me-2 fas fa-fw fa-store-alt"></i> {{ userInfo.shopInfo.name }}</h1>
      </div>
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-header">
              <h5 class="card-title mb-0">Infomation</h5>
            </div>
            <div class="card-body">
              <table class="table table-sm mt-2 mb-4">
                <tbody>
                  <tr>
                    <th>Shop ID</th>
                    <td> {{ userInfo.shopInfo.id }}</td>
                  </tr>
                  <tr>
                    <th>Name</th>
                    <td> {{ userInfo.shopInfo.name }}</td>
                  </tr>
                  <tr>
                    <th>Address</th>
                    <td>{{ userInfo.shopInfo.address }}</td>
                  </tr>
                  <tr>
                    <th>Code</th>
                    <td>{{ userInfo.shopInfo.code }}</td>
                  </tr>
                  <tr>
                    <th>Phone</th>
                    <td>{{ userInfo.shopInfo.phone }}</td>
                  </tr>
                  <tr>
                    <th>Suburb</th>
                    <td>{{ userInfo.shopInfo.suburb }}</td>
                  </tr>
                  <tr>
                    <th>Zipcode</th>
                    <td>{{ userInfo.shopInfo.postcode }}</td>
                  </tr>
                  <tr>
                    <th>Status</th>
                    <td><span class="badge bg-success">Active</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapState } from "vuex"
export default {
  data() {
    return {}
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.auth.userInfo
    })
  }
}
</script>